import React, { useEffect, useState } from "react";
import DTOGovtTaxEditModal from "./DTOGovtTaxEditModal";
import GovtTaxEditModalPresenter from "./GovtTaxEditModalPresenter";
import { useAppDispatch, useAppSelector } from "../../../../infra/hooks";
import _ from "lodash";
import { salaryService } from "../../../../api/services/salaryService";
import { setEmployeeAssignGovtTax } from "../../../../infra/aggregates/myProfile/salaryAggregates/empGovtTaxSlice";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
interface ModalInterface {
  isModalOpen: boolean;
  closeModal: any;
  trans?: any;
}

const GovtTaxEditModalController = ({
  isModalOpen,
  closeModal,
}: ModalInterface) => {
  const { t, i18n } = useTranslation();
  const [currency, setCurrency] = useState("");
  const selector = useAppSelector((state) => state.authSlice);
  const isLoading = useAppSelector((state) => state.LoaderSlice.Loading);
  const empAssignedTaxes = useAppSelector(
    (state) => state.empGovtTaxSlice.empGovtTax
  );
  const dispatch = useAppDispatch();
  const taxIDs = _.map(empAssignedTaxes, "id");

  const [allGovtTaxes, setAllGovtTaxes] = useState([]);
  const getAllTaxes = (taxes: any) => {
    setAllGovtTaxes(taxes);
  };

  const getData = (taxes: any) => {
    updateEmergencyContactDetail(taxes.taxIds);
  };

  const getCurrency = (data: any) => {
    setCurrency(data);
  };
  async function updateEmergencyContactDetail(data: any) {
    if (selector.emp_id && selector?.company_id && data) {
      const payload = {
        emp_Id: selector.emp_id,
        gov_taxIds: data,
        company_id: selector.company_id,
      };
      await salaryService
        .editEmpGovernmentTax(payload)
        .then((response) => {
          if (response.response === "success") {
            dispatch(setEmployeeAssignGovtTax(response?.data));
            toast.success(t("Updated Successfully"));
          }
        })
        .catch((err) => {
          toast.error(err?.response?.data?.message);
        });
    } else {
      toast.error(t("Invalid data"));
    }
  }
  return (
    <div>
      <DTOGovtTaxEditModal
        setCurrency={getCurrency}
        setAllGovtTaxes={getAllTaxes}
      />

      <GovtTaxEditModalPresenter
        callBackData={getData}
        isModalOpen={isModalOpen}
        closeModal={closeModal}
        govtTaxes={allGovtTaxes}
        assignedTaxesToEmployees={taxIDs}
        currency={currency}
        isLoading={isLoading}
      />
    </div>
  );
};

export default GovtTaxEditModalController;
